import { displaySidebarMusic, fetchMediaFiles } from '~video';

export const onChangeMusic = async () => {
  await fetchMediaFiles();
  await displaySidebarMusic();
};
